<div class="account-pages mt-5 mb-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-5">
                <div class="card">

                    <!-- Logo -->
                    <div class="card-header pt-4 pb-4 text-center bg-primary">
                        <a href="#">
                            <span><img src="assets/layout/images/login/facturafacilecuador.png" alt="appsventas-layout" height="auto"></span>
                        </a>
                    </div>
                    <!-- start message -->
                    <div class="card-body p-4">

                        <div class="text-center w-75 m-auto">
                            <h4 class="text-dark-50 text-center mt-0 font-weight-bold">{{ title }}</h4>
                            <p class="text-muted mb-4">Ingrese su nombre usuario y contraseña</p>
                            <p class="text-muted mb-4"><p-messages [(value)]="msgs"></p-messages></p>
                        </div>
                        <form [formGroup]="authForm" (ngSubmit)="submitForm()">
                            <fieldset [disabled]="isSubmitting">
                                <fieldset class="form-group">
                                    <input
                                        formControlName="username"
                                        placeholder="Nombre de usuario"
                                        maxlength="128"
                                        class="form-control form-control-lg"
                                        type="text"/>
                                </fieldset>
                                <fieldset class="form-group">
                                    <input
                                        formControlName="email"
                                        placeholder="Correo electrónico"
                                        class="form-control form-control-lg"
                                        type="text" 
                                        *ngIf="authType == 'register'" />
                                </fieldset>
                                <fieldset class="form-group">
                                    <input
                                        formControlName="password"
                                        placeholder="Contraseña"
                                        maxlength="37"
                                        class="form-control form-control-lg"
                                        type="password" />
                                </fieldset>

                                <!--                                <div class="form-group mb-3">
                                                                    <div class="custom-control custom-checkbox">
                                                                        <input type="checkbox" class="custom-control-input" id="checkbox-signin" checked>
                                                                        <label class="custom-control-label" for="checkbox-signin">Remember me</label>
                                                                    </div>
                                                                </div>-->

                                <div class="form-group mb-0 text-center">
                                    <button class="btn btn-lg btn-primary pull-xs-right" [disabled]="!authForm.valid" type="submit">
                                        {{ title }}
                                    </button>
                                </div>
                            </fieldset>
                        </form>
                    </div> <!-- end card-body -->
                </div>
                <!-- end card -->

                <div class="row mt-3">
                    <div class="col-12 text-center">

                        <!--<p class="text-muted">¿Tiene una cuenta? <a [routerLink]="['/login']" *ngIf="authType == 'register'">Ingresar</a></p>-->
                        <p class="text-muted">¿Obtener un plan ahora?<a [routerLink]="['/registrar']" *ngIf="authType == 'login'">Empezar ahora</a></p>
                    </div> <!-- end col -->
                </div>
                <!-- end row -->

            </div> <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</div>
<!-- end page -->
